import loader_module_default from "./loader.module.js";
import { Loader } from "@mantine/core";
import { jsx } from "react/jsx-runtime";

//#region src/components/loader/Loader.tsx
const Loader$1 = ({ size, color, "data-testid": testId }) => {
	return /* @__PURE__ */ jsx(Loader, {
		color,
		size,
		type: "oval",
		classNames: loader_module_default,
		"data-testid": testId
	});
};

//#endregion
export { Loader$1 as Loader };